import axios from "axios";
import { NewPatient } from "../../types";
import AuthService from "../AuthService";
import { IPatientService } from "../IPatientService";

const API_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_API_URL || "http://localhost:8080"
    : process.env.REACT_APP_API_URL || "https://gdm-api.dev.rpm.platform.navify.com/gdm-patient-service/api/v1";

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(async (config) => {
  const token = await AuthService.getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export class PatientApiService implements IPatientService {
  async getPatients() {
    const response = await apiClient.get("/patients");
    return response.data;
  }

  async getPatientDetails(patientId: string) {
    const response = await apiClient.get(`/patients/${patientId}`);
    return response.data;
  }

  async createPatient(patient: NewPatient) {
    const response = await apiClient.post("/patients", patient);
    return response.data;
  }

  async getPatientBloodGlucose(patientId: string, days: number = 7) {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);
    const response = await apiClient.get(
      `/patients/${patientId}/metrics/blood-glucose`,
      {
        params: {
          startDate: startDate.toISOString().split("T")[0],
          endDate: endDate.toISOString().split("T")[0],
        },
      }
    );
    return response.data;
  }

  async getPatientWeight(patientId: string, days: number = 7) {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);
    const response = await apiClient.get(
      `/patients/${patientId}/metrics/weight`,
      {
        params: {
          startDate: startDate.toISOString().split("T")[0],
          endDate: endDate.toISOString().split("T")[0],
        },
      }
    );
    return response.data;
  }

  async getPatientCalories(patientId: string, days: number = 7) {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);
    const response = await apiClient.get(
      `/patients/${patientId}/metrics/calories`,
      {
        params: {
          startDate: startDate.toISOString().split("T")[0],
          endDate: endDate.toISOString().split("T")[0],
        },
      }
    );
    return response.data;
  }

  async getPatientActivity(patientId: string, days: number = 7) {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);
    const response = await apiClient.get(
      `/patients/${patientId}/metrics/activity`,
      {
        params: {
          startDate: startDate.toISOString().split("T")[0],
          endDate: endDate.toISOString().split("T")[0],
        },
      }
    );
    return response.data;
  }
}
